var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.currentRouteName !== 'Homepage')?[_c('AppHeader',{attrs:{"headerTop":true,"currentUser":_vm.currentUser}}),_c('v-content',{staticClass:"blue-grey lighten-5 py-8"},[_c('router-view',{attrs:{"currentUser":_vm.currentUser}})],1),_c('AppFooter')]:_c('router-view',{attrs:{"currentUser":_vm.currentUser}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }